import Vue from 'vue'
import VueRouter from 'vue-router'

// Routes
import { routes as adminRoutes } from './admin.routes'
import { routes as clienteRoutes } from './cliente.routes'
import { routes as comercianteRoutes } from './comerciante.routes'
import { routes as sharedRoutes } from './shared.routes';

import { AuthFacade as ComercianteAuthFacade } from '../service/comerciante/auth/auth.facade'

Vue.use(VueRouter)

const router = new VueRouter({
  routes: [
    ...adminRoutes,
    ...clienteRoutes,
    ...comercianteRoutes,
    ...sharedRoutes,
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      if (to.hash && to.hash != '#') {
        return {
          selector: to.hash,
          behavior: 'smooth',
        }
      }
      return { x: 0, y: 0 }
    }
  },
})

router.beforeEach((to, from, next) => {
  // Panel Admin
  if (
    (to.path === '/panel' || to.path.includes('panel/')) &&
    !localStorage.getItem('adminUser')
  ) {
    next('/login')
    return
  }

  // Panel comerciante
  if (
    (to.path === '/comerciante' || to.path.includes('comerciante/')) &&
    !ComercianteAuthFacade.isLoggedIn()
  ) {
    // Redireccionar al login
    next({ name: 'InicioLogin' })
    return
  }

  next()
})

export default router
